<ng-container *appLoader="!currentTenantId">
  <h1 mat-dialog-title>{{ data.title }}</h1>
  <div mat-dialog-content>
    <mat-form-field
      appearance="outline"
      class="ui-select-field ui-form-field-v2"
      subscriptSizing="dynamic"
    >
      <mat-label>Tenant Id</mat-label>
      <mat-select [(ngModel)]="currentTenantId" [hideSingleSelectionIndicator]="true">
        @for (tenantId of data.tenants; track tenantId.id) {
          <mat-option [value]="tenantId.id">{{ tenantId.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      class="ui-button-control ui-button--primary"
      type="button"
      cdkFocusInitial
      (click)="chooseTenantId()"
    >
      <span class="ui-button__label">{{ 'choose' | translate }}</span>
    </button>
  </div>
</ng-container>
